module.exports = __webpack_public_path__ + "img/Frame 1102hrp1.f05f4ba9.png";